import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import Lottie from 'react-lottie';
import { Typography } from '@material-ui/core';
import Button from '../../components/buttons/Button';
import notFoundImg from '../../assets/404.json';

import { useStyles } from './styles';

const NotFound: React.FC = () => {
  const classes = useStyles();
  const history = useHistory();
  const { t } = useTranslation();

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: notFoundImg,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  };

  return (
    <div className={classes.container}>
      <Lottie options={defaultOptions} height={120} width={400} />
      <Typography variant="h1" className={classes.message}>
        {t('screens:notFound.pageNotFound')}
      </Typography>
      <Button
        type="button"
        className={classes.button}
        onClick={() => history.push('/dashboard')}
      >
        {t('screens:notFound.goHome')}
      </Button>
    </div>
  );
};

export default NotFound;
